<template>
  <div class="content-wrapper">
    <div class="col-12 mb-primary">
      <div class="card card-with-shadow border-0 h-100">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body training-details-card" :class="{ 'loading-opacity': preloader }">
          <div class="training-details-hero">
            <div class="training-details-kicker">{{ $t("Training Course") }}</div>
            <h2 class="training-details-title">{{ certificate.display_title || certificate.title || "---" }}</h2>
            <div class="training-details-pricing">
              {{ certificate.pricing_type === 'credit_based' ? `${certificate.credit_usage || 0} Credits Required` : 'Free Course' }}
            </div>
            <p class="training-details-subtitle">
              {{ $t("Review the course summary below before starting the assigned forms and training steps.") }}
            </p>
          </div>

          <div class="training-details-section">
            <div class="training-details-label">{{ $t("About This Course") }}</div>
            <div
              v-if="certificate.description"
              class="training-details-description"
              v-html="certificate.description"
            ></div>
            <p v-else class="training-details-empty">{{ $t("No course description available.") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import {
  COMPANY_JOB_SITE_STORE,
  COMPANY_JOB_STORE,
  CATEGORIES,
  DROPDOWN,
  BUYER_CERTIFICATE_APPLIED_GET,
} from "../../../../../Config/ApiUrl.js";
import { axiosPost, axiosGet } from "../../../../../Helpers/AxiosHelper.js";

export default {
  name: "AppliedCertificateDetails",
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      certificate: {},
    };
  },
  methods: {
    submit() {
      this.save(this.inputs);
    },
    afterFinalResponse() {
      this.preloader = false;
      this.inputs = {
        gender: "male",
      };
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    clear() {
      this.inputs = {};
      this.fieldStatus = {
        isSubmit: false,
      };
    },
    beforeSubmit() {
      this.preloader = true;
    },
    storeJob() {
      // this.seen = true;
      let formData = new FormData();
      if (this.dropzone_files.length) {
        this.dropzone_files.forEach((dropzone_file) => {
          formData.append(`dropzone_file[]`, dropzone_file);
        });
      }
      Object.keys(this.job).forEach((key) => {
        formData.append(key, this.job[key]);
      });
      this.save(formData);
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
      this.job.id = res.data.job_id;
      this.$toastr.s(res.data.message);
      this.job = {};
      window.location = "/buyer/job";
    },
    getCategories() {
      axiosGet(CATEGORIES)
        .then((res) => {
          this.category = res.data;
        })
        .catch((error) => {
          
        });
    },
    getDropdown() {
      axiosGet(DROPDOWN)
        .then((res) => {
          this.regionlist = res.data.region;
          this.threshold = res.data.threshold;
          this.framework = res.data.framework;
          this.noticetypelist = res.data.noticetype;
        })
        .catch((error) => {
          
        });
    },

    getCertificate(id) {
      axiosGet(BUYER_CERTIFICATE_APPLIED_GET + "/" + id)
        .then((res) => {
          this.certificate = res.data;
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    // let myLocation = location.href;
    // let split = myLocation.split("/");
    
    // let id = split[7].split("?")[0];
    let id = this.$attrs['props'].certificate_id;
    
    this.getCertificate(id);
  },
};
</script>

<style scoped>
.training-details-card {
  padding: 2rem;
}

.training-details-hero {
  padding: 1.5rem 1.75rem;
  border-radius: 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #eef4ff 100%);
  border: 1px solid #dde7f5;
  margin-bottom: 1.5rem;
}

.training-details-kicker {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5b6c8f;
  margin-bottom: 0.5rem;
}

.training-details-title {
  font-size: 2rem;
  line-height: 1.2;
  color: #1f2a44;
  margin-bottom: 0.75rem;
}

.training-details-subtitle {
  max-width: 760px;
  margin: 0;
  font-size: 1rem;
  color: #5f6b7a;
}

.training-details-pricing {
  display: inline-block;
  margin-bottom: 1rem;
  padding: 0.45rem 0.85rem;
  border-radius: 999px;
  background: #1f2a44;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
}

.training-details-section {
  background: #fff;
  border: 1px solid #e5eaf1;
  border-radius: 16px;
  padding: 1.5rem 1.75rem;
}

.training-details-label {
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #4d5c7d;
  margin-bottom: 1rem;
}

.training-details-description {
  color: #263447;
  font-size: 1rem;
  line-height: 1.8;
}

.training-details-description :deep(p) {
  margin-bottom: 1rem;
}

.training-details-description :deep(ul),
.training-details-description :deep(ol) {
  padding-left: 1.25rem;
  margin-bottom: 1rem;
}

.training-details-description :deep(h1),
.training-details-description :deep(h2),
.training-details-description :deep(h3),
.training-details-description :deep(h4) {
  color: #1f2a44;
  margin: 1.25rem 0 0.75rem;
}

.training-details-empty {
  margin: 0;
  color: #7b8794;
}
</style>
